import { useEffect, useState } from "react";
import axios from "axios";
import "../../assets/styles/studentprofile.css";

function StudentProfile() {

  const [student, setStudent] = useState({});
  const studentId = localStorage.getItem("studentId");

  useEffect(() => {

    axios.get(`https://shuttle-craft-student-transport.onrender.com/api/students/${studentId}`)
      .then(res => {
        console.log(res.data);
        setStudent(res.data);
      });

  }, []);

  return (
    <div className="profile-container">
  
      <div className="profile-card">
  
        <h2>My Profile</h2>
  
        <div className="profile-item">
          <span>Name</span>
          <p>{student.name} 👋</p>
        </div>
  
        <div className="profile-item">
          <span>Phone</span>
          <p>{student.phone}</p>
        </div>
  
        <div className="profile-item">
          <span>Batch</span>
          <p>{student.batch}</p>
        </div>
  
        <div className="profile-item">
          <span>Coach</span>
          <p>{student.coach}</p>
        </div>
  
        <div className="profile-item">
          <span>Slot</span>
          <p>{student.slot}</p>
        </div>
  
      </div>
  
    </div>
  );
}

export default StudentProfile;